import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { useQuery } from '@apollo/client';

import { QUERY_LINKS } from '../../utils/queries';

import Carousel from 'react-bootstrap/Carousel';

import spinner from '../../assets/spinner.gif';
import DealGridItem from '../DealGridItem';

import './DealGrid.css';

function DealGrid() {
  const dispatch = useDispatch();

  const [links, setLinks] = useState([]);

  const { loading, data } = useQuery(QUERY_LINKS);

  useEffect(() => {
    if (data) {
      // Restrict to four, to control layout
      // TODO: Make sure 4 most recent deals are shown
      setLinks(
        data.links
          .filter(link => link.active && link.image && link.dealText)
          .slice(0, 4));
    }
  }, [data, loading, dispatch]);

  return (
    <>
      {loading ? <img src={spinner} alt="loading" /> :
        (links.length ?
          <div className="deal-grid flex-row">
            {links.map(link => (
              <DealGridItem key={link._id} link={link}/>
            ))}
          </div> : null
        )}
    </>
  );
}

export default DealGrid;
